// extracted by mini-css-extract-plugin
export default {"mainColumnClassName":"LandingPage_mainColumnClassName__Ew5Ac"};